import {
  initializeFirestore,
  getFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { app } from "./index";

// Caché persistente en IndexedDB. Sin ella, cada apertura de la app re-descarga (y factura)
// TODAS las colecciones del usuario. Con ella, el listener reanuda con un *resume token* y el
// servidor solo manda los documentos que cambiaron desde la última vez.
//
// Seguimos siendo "online-only" para ESCRIBIR (ver `_verificarConexion` en los stores): sin
// conexión no se guarda nada. La caché se aprovecha para las lecturas y el arranque en frío.
//
// `persistentMultipleTabManager` permite tener la app abierta en varias pestañas a la vez; con el
// manager por defecto, la segunda pestaña se queda sin caché.
function crearDb() {
  try {
    return initializeFirestore(app, {
      localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
    });
  } catch (e) {
    // IndexedDB puede no estar disponible (Safari en modo privado, almacenamiento bloqueado).
    // La app funciona igual, solo que sin caché entre sesiones.
    console.warn("Sin caché persistente de Firestore, se usa memoria:", e);
    return getFirestore(app);
  }
}

export const db = crearDb();
